import { SAVE_PATIENT_COUNT } from '../actions/actionTypes';

const initialState = {};

const patientCount = (state, action) => {
  if (typeof state === 'undefined') {
    return initialState;
  } else {
    if (action.type === SAVE_PATIENT_COUNT) {
      return {
        ...state,
        ...action.payload,
      };
    } else {
      return state;
    }
  }
};

export default patientCount;
